<template>
  <el-dialog
    :title="type == 0 ? '新增绑定' : '删除绑定'"
    :visible.sync="visible"
    width="480px"
    @close="reset"
    :close-on-click-modal="false"
    custom-class="pub_dialog"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="用户名" label-width="80px" prop="userName">
        <el-input
          v-model="form.userName"
          autocomplete="off"
          placeholder="请输入邮箱地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="应用ID" label-width="80px" prop="appId">
        <el-input
          v-model="form.appId"
          autocomplete="off"
          placeholder="请输入应用ID(多个应用使用英文,隔开)"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="submit('form')" :loading="loading">{{
        loading ? "提交中" : "提交"
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { email } from "@/utils/regexp.js";
import {
  addPlayerAppIdBind,
  deletePlayerAppIdBind,
} from "@/api/playerAppIdBind.js";
export default {
  data() {
    var rule_pw = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("应用ID不得为空!"));
      } else {
        callback();
      }
    };
    var rule_at = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("账号不得为空！"));
      } else {
        if (!email.test(value)) {
          return callback(new Error("请输入正确邮箱"));
        }
        callback();
      }
    };
    return {
      form: {
        userName: "",
        appId: "",
      },
      rules: {
        userName: [{ required: true, validator: rule_at, trigger: "blur" }],
        appId: [{ required: true, validator: rule_pw, trigger: "blur" }],
      },
      visible: false,
      loading: false,
      type: 0,
    };
  },
  methods: {
    show(type, userName) {
      this.type = type;
      if (userName) {
        this.form.userName = userName;
      }
      this.visible = true;
    },
    submit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let res =
            this.type == 0
              ? await addPlayerAppIdBind(this.form)
              : await deletePlayerAppIdBind(this.form);
          this.isLoading = false;
          if (res === "ok") {
            this.$message({
              showClose: true,
              type: "success",
              message: "绑定成功",
            });
            this.loading = false;
            this.visible = false;
            this.$listeners.getData();
          }
        } else {
          return false;
        }
      });
    },
    reset(done) {
      this.loading = false;
      this.form.userName = "";
      this.$refs.form.resetFields();
      done();
    },
  },
};
</script>

<style></style>
